import {
  UPDATE_DEPRECIATION_SELECTED_MODEL_BEGIN,
  UPDATE_DEPRECIATION_SELECTED_MODEL_SUCCESS,
  UPDATE_DEPRECIATION_SELECTED_MODEL_FAILURE,
} from './constants';

export function updateDepreciationSelectedModel(modelId) {
  return async(dispatch) => { 
    dispatch({
      type: UPDATE_DEPRECIATION_SELECTED_MODEL_BEGIN,
    });
    try{
      
      dispatch({
          type: UPDATE_DEPRECIATION_SELECTED_MODEL_SUCCESS,
          data: modelId,
      });
    }catch(error){
      dispatch({
          type: UPDATE_DEPRECIATION_SELECTED_MODEL_FAILURE,
          data: error,
      });
    }
  }
  }


export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_DEPRECIATION_SELECTED_MODEL_BEGIN:
      return {
        ...state,
        updateDepreciationYearPending: true,
        updateDepreciationYearError: null,
      };

    case UPDATE_DEPRECIATION_SELECTED_MODEL_SUCCESS:
      return {
        ...state,
        depreciationSelectedModelId: action.data,
        updateDepreciationYearPending: false,
        updateDepreciationYearError: null,
      };

    case UPDATE_DEPRECIATION_SELECTED_MODEL_FAILURE:
      return {
        ...state,
        updateDepreciationYearPending: false,
        updateDepreciationYearError: action.data.error,
      };
    default:
      return state;
  }
}
